import type {Theme} from '@material-ui/core/styles';
import {createStyles} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        fontSize: 16,
        lineHeight: 1.5,
        '& .MuiFormLabel-root': {
            ...theme.typography.body2,
            color: theme.palette.text.primary,
        },
        '& label.Mui-focused': {
            color: theme.palette.text.primary,
        },
        '& .MuiInputBase-root': {
            lineHeight: theme.spacing(8),
            color: '#393832',
        },
        '& input:valid + fieldset': {
            borderBottomColor: theme.palette.success.main,
        },
        '& input:invalid + fieldset': {
            borderBottomColor: `${theme.palette.error.main} !important`,
        },
        '& input:valid:focus + fieldset': {
            borderBottomColor: `${theme.palette.success.main} !important`,
        },
    },
}));
